import { ORG_ENVIRONMENT, type OrgEnvironment } from "@/frontend/types/org";

/** Connection lifecycle states that mean records can still arrive. */
const HEALTHY_STATUSES = new Set(["active"]);

/** Whether a connection is currently able to return records. */
export function isConnectionHealthy(status: string): boolean {
  return HEALTHY_STATUSES.has(status);
}

/**
 * Placeholder and empty-state copy for a health system search, which the server
 * scopes to the active workspace's environment. A sandbox workspace carries a
 * handful of seeded sandbox endpoints, so promising 40,000+ there and then
 * reporting no match for a real hospital reads as a broken search.
 *
 * @param environment the active workspace's environment
 */
export function healthSystemSearchCopy(environment: OrgEnvironment): {
  placeholder: string;
  emptyFor: (query: string) => string;
} {
  if (environment === ORG_ENVIRONMENT.SANDBOX) {
    return {
      placeholder: "Search sandbox health systems",
      emptyFor: (query) =>
        `No sandbox health system matches \u201c${query}\u201d. This workspace searches sandbox endpoints only. Switch to Production to reach real hospitals, clinics and insurers.`,
    };
  }
  return {
    placeholder: "Search 40,000+ health systems",
    emptyFor: (query) => `No health systems match \u201c${query}\u201d`,
  };
}
